import Chart from 'chart.js'
import { backgroundColors } from '../constants/chart'

const Graphs = () => {
  const charts = document.querySelectorAll('.js-chart')
  if (!charts.length) return;

  [ ...charts ].forEach(chart => {
    const { type, labels, data } = chart.dataset
    switch (type) {
      case 'stacked':
        stackedChart(chart, labels, data)
        break
      case 'bar':
        barChart(chart, labels, data)
        break
      case 'double':
        doubleChart(chart, labels, data)
        break
    }
  })
}

const doubleChart = (chart, labels, data) => {
  const canvas = chart.children[0] || false
  const backgrounds = [ '#fd9726', '#2178cf' ]
  const datasets = data.split('|').map((set, i) => {
    const data = set.split(',').map(i => parseInt(i, 10))
    return { label: '', backgroundColor: backgrounds[i], data }
  })
  return new Chart(canvas, {
    type: 'bar',
    options: { legend: { display: false }, scales: {} },
    data: { labels: labels.split(','), datasets }
  })
}

const barChart = (chart, labels, data) => {
  const canvas = chart.children[0] || false
  return new Chart(canvas, {
    type: 'bar',
    options: {
      legend: { display: false },
      scales: { yAxes: [ { stacked: true } ] }
    },
    data: {
      labels: labels.split(','),
      datasets: [
        {
          label: '',
          data: data.split(',').map(i => parseInt(i, 10)),
          backgroundColor: backgroundColors[1]
        }
      ]
    }
  })
}

const stackedChart = (chart, labels, data) => {
  // Data is like this 12, 13, 14|15,12,13|etc..
  const backgrounds = [ '#378e46', '#fdc031', '#d12f35' ]
  const keys = data.split('|')
  const canvas = chart.children[0] || false
  const datasets = keys.map((set, i) => {
    const data = set.split(',').map(item => parseInt(item, 10))
    return { label: '', data, backgroundColor: backgrounds[i], borderWidth: 1 }
  })

  return new Chart(canvas, {
    type: 'bar',
    options: {
      legend: { display: false },
      scales: { xAxes: [ { stacked: true } ], yAxes: [ { stacked: true } ] }
    },
    data: { labels: labels.split(','), datasets: datasets }
  })
}

export default Graphs

Chart.defaults.global.defaultFontColor = '#39404a'
Chart.defaults.global.defaultFontFamily = "'museo-sans', sans-serif"



// WEBPACK FOOTER //
// ./src/js/modules/Graphs.js